import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _demoDocumentContent = {
    pages: '_papyrusTicketPage',
    content: '_papyrusTicketContent',
};
var _downloadPkPassRequest = {};
var _getDemoTicketDocumentContentRequest = {};
var _getDemoTicketDocumentContentResponse = {
    documentContent: '_demoDocumentContent',
};
var _getDownloadUrlPublicRequest = {};
var _getDownloadUrlPublicResponse = {};
var _getDownloadUrlRequest = {};
var _getDownloadUrlResponse = {};
var _getTicketDocumentContentRequest = {};
var _getTicketDocumentContentResponse = {
    typedDocumentContent: '_typedDocumentContent',
};
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _papyrusTicketContent = { mainImage: '_image' };
var _papyrusTicketPage = { mainImage: '_image' };
var _rawHttpResponse = { body: 'BYTES' };
var _redirectToDownloadPageRequest = {};
var _resolveTicketDocumentRequest = {};
var _resolveTicketDocumentResponse = {};
var _typedDocumentContent = {
    pages: '_papyrusTicketPage',
    content: '_papyrusTicketContent',
};
function resolveWixEventsTicketsV2TicketManagementUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/events-tickets',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/tickets/download',
                destPath: '/download',
            },
            {
                srcPath: '/tickets/passes/download',
                destPath: '/passes/download',
            },
        ],
        _: [
            {
                srcPath: '/_api/events-tickets',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEventsTicketsV2PapyrusTicketServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/events-tickets',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/tickets/download',
                destPath: '/download',
            },
            {
                srcPath: '/tickets/passes/download',
                destPath: '/passes/download',
            },
        ],
        _: [
            {
                srcPath: '/_api/events-tickets',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveWixEventsTicketsV2DownloadControllerUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/events-tickets',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/tickets/download',
                destPath: '/download',
            },
            {
                srcPath: '/tickets/passes/download',
                destPath: '/passes/download',
            },
        ],
        _: [
            {
                srcPath: '/_api/events-tickets',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Redirects to download page. */
export function redirectToDownloadPage(payload) {
    var _a = serializer(_redirectToDownloadPageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __redirectToDownloadPage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.ticket',
            method: 'GET',
            methodFqn: 'wix.events.tickets.v2.DownloadController.RedirectToDownloadPage',
            url: resolveWixEventsTicketsV2DownloadControllerUrl({
                protoPath: '/download',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __redirectToDownloadPage.fromReq = fromReq;
    __redirectToDownloadPage.__isAmbassador = true;
    return __redirectToDownloadPage;
}
/** Downloads PK pass. */
export function downloadPkPass(payload) {
    var _a = serializer(_downloadPkPassRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_rawHttpResponse, {}).fromJSON;
    function __downloadPkPass(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.ticket',
            method: 'GET',
            methodFqn: 'wix.events.tickets.v2.DownloadController.DownloadPkPass',
            url: resolveWixEventsTicketsV2DownloadControllerUrl({
                protoPath: '/passes/download',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __downloadPkPass.fromReq = fromReq;
    __downloadPkPass.__isAmbassador = true;
    return __downloadPkPass;
}
/** Generates ticket document content */
export function getTicketDocumentContent(payload) {
    var _a = serializer(_getTicketDocumentContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTicketDocumentContentResponse, {
        _image: _image,
        _papyrusTicketContent: _papyrusTicketContent,
        _papyrusTicketPage: _papyrusTicketPage,
        _typedDocumentContent: _typedDocumentContent,
    }).fromJSON;
    function __getTicketDocumentContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.ticket',
            method: 'GET',
            methodFqn: 'wix.events.tickets.v2.PapyrusTicketService.GetTicketDocumentContent',
            url: resolveWixEventsTicketsV2PapyrusTicketServiceUrl({
                protoPath: '/v2/tickets/document-content',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTicketDocumentContent.fromReq = fromReq;
    __getTicketDocumentContent.__isAmbassador = true;
    return __getTicketDocumentContent;
}
/** Generates ticket document content */
export function getDemoTicketDocumentContent(payload) {
    var _a = serializer(_getDemoTicketDocumentContentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDemoTicketDocumentContentResponse, { _demoDocumentContent: _demoDocumentContent, _image: _image, _papyrusTicketContent: _papyrusTicketContent, _papyrusTicketPage: _papyrusTicketPage }).fromJSON;
    function __getDemoTicketDocumentContent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.ticket',
            method: 'GET',
            methodFqn: 'wix.events.tickets.v2.PapyrusTicketService.GetDemoTicketDocumentContent',
            url: resolveWixEventsTicketsV2PapyrusTicketServiceUrl({
                protoPath: '/v2/tickets/demo-document-content',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDemoTicketDocumentContent.fromReq = fromReq;
    __getDemoTicketDocumentContent.__isAmbassador = true;
    return __getDemoTicketDocumentContent;
}
/** Resolve ticket document */
export function resolveTicketDocument(payload) {
    var _a = serializer(_resolveTicketDocumentRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_resolveTicketDocumentResponse, {}).fromJSON;
    function __resolveTicketDocument(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.ticket',
            method: 'POST',
            methodFqn: 'wix.events.tickets.v2.PapyrusTicketService.ResolveTicketDocument',
            url: resolveWixEventsTicketsV2PapyrusTicketServiceUrl({
                protoPath: '/v2/tickets/resolve-ticket-document',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __resolveTicketDocument.fromReq = fromReq;
    __resolveTicketDocument.__isAmbassador = true;
    return __resolveTicketDocument;
}
/** Get download urls */
export function getDownloadUrl(payload) {
    var _a = serializer(_getDownloadUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDownloadUrlResponse, {}).fromJSON;
    function __getDownloadUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.ticket',
            method: 'GET',
            methodFqn: 'wix.events.tickets.v2.TicketManagement.GetDownloadUrl',
            url: resolveWixEventsTicketsV2TicketManagementUrl({
                protoPath: '/v2/tickets/download',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDownloadUrl.fromReq = fromReq;
    __getDownloadUrl.__isAmbassador = true;
    return __getDownloadUrl;
}
export function getDownloadUrlPublic(payload) {
    var _a = serializer(_getDownloadUrlPublicRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDownloadUrlPublicResponse, {}).fromJSON;
    function __getDownloadUrlPublic(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v2.ticket',
            method: 'GET',
            methodFqn: 'wix.events.tickets.v2.TicketManagement.GetDownloadUrlPublic',
            url: resolveWixEventsTicketsV2TicketManagementUrl({
                protoPath: '/v2/tickets/download-public',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDownloadUrlPublic.fromReq = fromReq;
    __getDownloadUrlPublic.__isAmbassador = true;
    return __getDownloadUrlPublic;
}
//# sourceMappingURL=http.impl.js.map